/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import * as _ from 'lodash';

import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { AllocDeallocData } from '../shared/model/alloc-dealloc-data.model';
import { AllocationStation } from '../../core/model/allocation-station.model';
import { AppUtilityService } from './../../core/services/app-utility.service';
import { BaseResponse } from '../../core/model/base-response.model';
import { BreTransferAreaDetails } from '../../core/model/bre-transfer-area-details.model';
import { ConfigService } from './../../core/services/config.service';
import { DataStoreService } from './../../core/services/datastore.service';
import { DivisionStation } from './../shared/model/division-station.model';
import { EditModeService } from '../../core/services/edit-mode.service';
import { Header } from '../../core/model/header.model';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsException } from '../../core/model/lms-exception.model';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { LmsMenuService } from '../../core/services/lms-menu.service';
import { LmsModuleService } from '../../core/services/lms-module.service';
import { LocoDetail } from '../../core/model/loco-detail.model';
import { LocoFeature } from '../../loco/shared/model/loco-feature.model';
import { LocoTransfer } from './../../core/model/loco-transfer.model';
import { MessageDetails } from './../../core/model/message-details.model';
import { MessageHandlerService } from './../../core/services/message-handler.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from '../../core/services/static-datastore.service';
import { StationCityState } from '../shared/model/station-city-state.model';
import { StationDetail } from '../shared/model/station-detail.model';
import { StationLocoDetail } from '../shared/model/station-loco-detail.model';
import { TabData } from '../../core/model/tab-data.model';
import { TabService } from '../../core/services/tab.service';
import { TerminalDivision } from '../../core/model/terminal-division.model';
import { UtilService } from '../../core/services/util.service';
import { YardAndLocalRequest } from '../shared/model/yard-local-request.model';
import { YardLocalDetail } from './../shared/model/yard-local-detail.model';
import { YardLocalLocateData } from './../shared/model/yard-local-locate-data.model';
import { YardLocalService } from './../shared/services/yard-local.service';
import { YardLocalSubHeader } from '../shared/model/yard-local-sub-header.model';
import { PermitAll } from '@csx/security';
import { UserService } from '../../core/services/user.service';

/**
 * @export
 * @class YardLocalDataComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-yard-local-data',
  templateUrl: './yard-local-data.component.html',
  styleUrls: ['./yard-local-data.component.scss']
})
@PermitAll()
export class YardLocalDataComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  stationDetailArr: Array<StationDetail> = [];
  allStationDetailArr: Array<StationDetail> = [];
  selectedStationDetailArr: Array<StationDetail> = [];
  selectedStationLocoDetailArr: Array<StationLocoDetail> = [];
  selectedLocoDetailForPlanToTrainArr: Array<LocoDetail> = [];
  allocateLocomotiveArr: Array<StationLocoDetail> = [];
  deleteAllocationStationName?: string;
  yardLocalSubHeader: YardLocalSubHeader;
  isAllocateButtonEnabled: boolean;
  isDeAllocateButtonEnabled: boolean;
  isPlanButtonEnabled: boolean;
  isStationIconSelected: boolean;
  lasteRefreshedTime: string;
  isLoaded: boolean;
  yardLocalDetail: YardLocalDetail;
  selectedDivisionStation: DivisionStation;
  selectedSortBy = 'alphabeticByDivision';
  selectedAlphaSortType = 'asc';
  selectedNetAllocSortType = 'asc';
  selectedExtraPowerSortType = 'desc';

  configData: any;
  errorDialog: boolean;
  popupErrorMessage: string;

  planLocomotive: boolean;
  allocateLocomotive: boolean;
  deAllocateLocomotive: boolean;
  addOrUpdateAllocationStation: boolean;
  permannentAllocDialog: boolean;
  permannentAllocForDeallocDialog: boolean;
  permannentAllocMsg: string;
  addAllocateStation: boolean;
  updateAllocateStation: boolean;
  deleteAllocateStation: boolean;

  planOptions: SelectItem[];
  locoPlannedTo: string;
  confirmAction: string;
  confirmMessage: string;

  dialog: any;
  commonopsPicklist: any;
  allocationStationArr: Array<AllocationStation> = [];
  stationList: Array<SelectItem> = [];
  filteredResults: Array<string> = [];

  searchTextTerminal: string;
  searchTextTrain: string;

  isAddTrainError: boolean;
  searchPlanTextTerminalError: boolean;
  searchAllocationStationError: boolean;
  isValidThpSelection = false;

  roadTerminal1: string;
  roadTerminal1Transit: string;
  roadTerminal2: string;
  roadTerminal2Transit: string;
  yardLocalThpType = 'S';

  mileposts: string[] = [];
  mnemonics: string[] = [];

  /* for allocate popup */
  allocationType = 'YL';
  searchTextAllocationStation: string;
  permanentAllocation: boolean;
  allocateRole: string;

  ruleException = false;
  isRuleExceptionSubmitEnabled: boolean;
  lmsExceptionList: Array<LmsException> = [];
  transferResponse: BaseResponse;
  popUpServiceSubscription: any;
  responseHeader: Header;
  isOprFromContextMenu: boolean;

  // Add/update allocation station
  divisionList: Array<SelectItem> = [];
  stateCityList: Array<SelectItem> = [];

  addDivisionName: string;
  addAllocationStationName: string;
  addCityStateName: string;
  addRoadTerminal1: string;
  addRoadTerminal1Transit: string;
  addRoadTerminal2: string;
  addRoadTerminal2Transit: string;
  addSchedQMin: string;

  addDivisionNameError: boolean;
  addAllocationStationNameError: boolean;
  addRoadTerminal1Error: boolean;
  addRoadTerminal1TransitError: boolean;
  addRoadTerminal2Error: boolean;
  addRoadTerminal2TransitError: boolean;
  addSchedQMinError: boolean;
  yardLocalLocate: YardLocalLocateData;
  tabLevel: number;
  tabStoreSubscription: any;
  filteredTabs = [];
  locateLocoId: string;
  showHeader: boolean;

  addPtcFourAxleAllotment?: string;
  addPtcSixAxleAllotment?: string;
  addPtcRclFourAxleAllotment?: string;
  addPtcRclSixAxleAllotment?: string;
  addSlugAllotment?: string;
  addPtcSlugAllotment?: string;
  addRclFourAxleAllotment?: string;
  addRclSixAxleAllotment?: string;
  addPlatform?: string;
  addAxleFourAllotment?: string;
  addAxleSixAllotment?: string;

  addPtcFourAxleAllotmentError?: boolean;
  addPtcSixAxleAllotmentError?: boolean;
  addPtcRclFourAxleAllotmentError?: boolean;
  addPtcRclSixAxleAllotmentError?: boolean;
  addSlugAllotmentError?: boolean;
  addPtcSlugAllotmentError?: boolean;
  addRclFourAxleAllotmentError?: boolean;
  addRclSixAxleAllotmentError?: boolean;
  addPlatformError?: boolean;
  addAxleFourAllotmentError?: boolean;
  addAxleSixAllotmentError?: boolean;

  /**
   * Creates an instance of YardLocalDataComponent.
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {PopupService} popupService
   * @param {YardLocalService} yardLocalService
   *
   * @memberof YardLocalDataComponent
   */
  constructor(configService: ConfigService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    utilService: UtilService,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    popupService: PopupService,
    private yardLocalService: YardLocalService,
    private appUtilityService: AppUtilityService,
    private staticDataStoreService: StaticDataStoreService,
    private lmsLoaderService: LmsLoaderService,
    private dataStoreService: DataStoreService,
    private messageHandlerService: MessageHandlerService,
    private tabService: TabService,
    public user: UserService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.configData = configService.getConfigData();
    this.type = this.configData.menu.type.yardLocal;
    this.service = yardLocalService;
    this.dialog = this.configService.getConfigData().dialog;
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.setAllocateRole();
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });
    this.tabLevel = this.configService.getConfigData().tabIndex.dialogBox;
    if(staticDataStoreService.getValue('SHOW_HEADER') == false)
    {
        this.showHeader = false;
        // this.user.accessLevel = 'R';
    }
    else
        this.showHeader = true;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberof YardLocalDataComponent
   */
  ngOnInit() {
    this.lmsLoaderService.hideLoader();
    super.init(this.search);
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      if (this.commonopsPicklist.masterData.allocationStationList) {
        this.allocationStationArr = this.commonopsPicklist.masterData.allocationStationList;
      }
      if (this.commonopsPicklist.masterData.divisonList) {
        this.divisionList = [];
        this.divisionList.push({
          label: 'Select Division',
          value: ''
        });
        const divisionArr: Array<TerminalDivision> = this.commonopsPicklist.masterData.divisonList;
        if (divisionArr) {
          for (const terminalDivision of divisionArr) {
            this.divisionList.push({
              label: terminalDivision.divisionMenmonic + ' ' + terminalDivision.divisionName,
              value: terminalDivision.divisionMenmonic
            });
          }
        }
      }
    }
    // if (this.selectedTab) {
    //   if (this.selectedTab.yardLocalLocate && this.selectedTab.yardLocalLocate.allocationType) {
    //     this.selectedTab.yardLocalLocate.allocationType = this.convertAllocationTypeValue(this.selectedTab.yardLocalLocate.allocationType);
    //   }
    //   if (this.selectedTab.yardLocalLocate && this.selectedTab.yardLocalLocate.locomotiveId) {
    //     this.locateLocoId = this.selectedTab.yardLocalLocate.locomotiveId;
    //   }
    //   if (this.selectedTab.yardLocalLocate) {
    //     this.yardLocalLocate = this.selectedTab.yardLocalLocate;
    //     this.selectedTab.yardLocalLocate = {};
    //     this.updateTab(this.selectedTab);
    //   } else {
    //     this.yardLocalLocate = {};
    //   }
    //   if (this.dataStoreService.getValue(this.selectedTab)) {
    //     if (this.yardLocalLocate && this.yardLocalLocate.division) {
    //       if (this.isLocateDataExistInDataStore()) {
    //         this.getDataFromDataStore(this.yardLocalLocate.locomotiveId);
    //       } else {
    //         this.loadDataFromService(this.yardLocalLocate.division.trim().toUpperCase(), this.yardLocalLocate.allocationStation.trim(), this.yardLocalLocate.allocationType, '', false, '',
    //           this.yardLocalLocate.locomotiveId);
    //       }
    //     } else {
    //       this.getDataFromDataStore();
    //     }
    //   } else if (this.yardLocalLocate && this.yardLocalLocate.division && this.yardLocalLocate.allocationStation && this.yardLocalLocate.allocationType) {
    //     this.selectedDivisionStation = {
    //       division: this.yardLocalLocate.division.trim().toUpperCase(),
    //       allocationStation: this.yardLocalLocate.allocationStation.trim().toUpperCase()
    //     };
    //     this.loadDataFromService(this.yardLocalLocate.division.trim().toUpperCase(), this.yardLocalLocate.allocationStation.trim(), this.yardLocalLocate.allocationType, '', false, '');
    //   }
    // }

    this.tabStoreSubscription = this.tabService.tabStoreObservable.subscribe(data => {
      if (data) {
        const selectedTab = data.find((tab) => { return tab.selected; });
        if (selectedTab) {
          this.filteredTabs = data.filter((tab) => { return selectedTab.type === tab.type; });
        }
      }
    });


  }

  /**
   * Convert allocation type value.
   * @param {string} value
   * @returns {string}
   * @memberof YardLocalDataComponent
   */
  convertAllocationTypeValue(value: string): string {
    if (value) {
      if (value === 'YL') { value = 'Y'; }
      if (value === 'MW') { value = 'M'; }
      if (value === 'SP') { value = 'S'; }
      if (value === 'ALL') { value = 'A'; }
    }
    return value;
  }

  search() {
    super.search();
    this.isPlanButtonEnabled = false;
    this.isAllocateButtonEnabled = false;
    this.isDeAllocateButtonEnabled = false;
    this.isStationIconSelected = false;
    if (this.selectedTab) {
      if (this.selectedTab.yardLocalLocate && this.selectedTab.yardLocalLocate.allocationType) {
        this.selectedTab.yardLocalLocate.allocationType = this.convertAllocationTypeValue(this.selectedTab.yardLocalLocate.allocationType);
      }
      if (this.selectedTab.yardLocalLocate && this.selectedTab.yardLocalLocate.locomotiveId) {
        this.locateLocoId = this.selectedTab.yardLocalLocate.locomotiveId;
      } else {
        this.locateLocoId = null;
      }
      if (this.selectedTab.yardLocalLocate) {
        this.yardLocalLocate = this.selectedTab.yardLocalLocate;
        this.selectedTab.yardLocalLocate = {};
        this.updateTab(this.selectedTab);
      } else {
        this.yardLocalLocate = {};
      }
      if (this.dataStoreService.getValue(this.selectedTab)) {
        if (this.yardLocalLocate && this.yardLocalLocate.division) {
          if (this.isLocateDataExistInDataStore()) {
            this.getDataFromDataStore();
          } else {
            this.loadDataFromService(this.yardLocalLocate.division.trim().toUpperCase(), this.yardLocalLocate.allocationStation.trim(), this.yardLocalLocate.allocationType, '', false, '');
          }
        } else {
          this.getDataFromDataStore();
        }
      } else if (this.yardLocalLocate && this.yardLocalLocate.division && this.yardLocalLocate.allocationStation && this.yardLocalLocate.allocationType) {
        this.selectedDivisionStation = {
          division: this.yardLocalLocate.division.trim().toUpperCase(),
          allocationStation: this.yardLocalLocate.allocationStation.trim().toUpperCase()
        };
        if (!this.yardLocalLocate.fromLeftMenu) {
          this.loadDataFromService(this.yardLocalLocate.division.trim().toUpperCase(), this.yardLocalLocate.allocationStation.trim(), this.yardLocalLocate.allocationType, '', false, '');
        } else {
          this.stationDetailArr = [];
        }
      } else {
        if (this.selectedTab) {
          this.openDefaultYardLocal();
          this.setYardLocalSubHeader('Y', false);
        }
      }
    }
  }

  /**
   * Check locate data exist in data store or not.
   * @returns
   * @memberof YardLocalDataComponent
   */
  isLocateDataExistInDataStore() {
    this.yardLocalDetail = <YardLocalDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data);
    return (this.yardLocalDetail && this.yardLocalDetail.yardLocalSubHeader
      && this.yardLocalDetail.divisionStation && this.yardLocalLocate
      && this.yardLocalDetail.divisionStation.division.trim().toLowerCase() === this.yardLocalLocate.division.trim().toLowerCase()
      && this.yardLocalDetail.divisionStation.allocationStation.trim().toLowerCase() === this.yardLocalLocate.allocationStation.trim().toLowerCase()
      && this.yardLocalDetail.yardLocalSubHeader.yardLocalOption.trim().toLowerCase() === this.yardLocalLocate.allocationType.trim().toLowerCase());
  }
  /**
   * Retrieve data from datastore service.
   * @memberof YardLocalDataComponent
   */
  getDataFromDataStore(locoId?: string) {
    this.yardLocalDetail = <YardLocalDetail>(this.dataStoreService.getValue(this.selectedTab).data.Data);
    this.yardLocalSubHeader = this.yardLocalDetail.yardLocalSubHeader;
    this.allStationDetailArr = this.yardLocalDetail.allStationDetailArr;
    this.stationDetailArr = this.yardLocalDetail.stationDetailArr;
    this.lasteRefreshedTime = this.yardLocalDetail.lasteRefreshedTime;
    this.isLoaded = this.yardLocalDetail.isLoaded;
    this.selectedDivisionStation = this.yardLocalDetail.divisionStation;
    this.stationDetailArr.forEach((stationDetail) => {
      stationDetail.isStationSelected = false;
      stationDetail.listOfLocomotives.forEach((stationLocoDetail) => {
        stationLocoDetail.isLocoSelected = false;
      });
    });
    this.selectedSortBy = this.yardLocalDetail.selectedSortBy;
    this.selectedAlphaSortType = this.yardLocalDetail.selectedAlphaSortType;
    this.selectedNetAllocSortType = this.yardLocalDetail.selectedNetAllocSortType;
    this.selectedExtraPowerSortType = this.yardLocalDetail.selectedExtraPowerSortType;
    if (this.isLoaded) {
      this.allocStationSearchYardLocalEvent({yardLocalOption: this.yardLocalSubHeader.yardLocalOption, isIncludeSpecialAllocation : this.yardLocalSubHeader.isIncludeSpecialAllocation})
    }
  }

  /**
   * Set allocation/de-allocation role.
   * @memberof YardLocalDataComponent
   */
  setAllocateRole() {
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist &&
      this.commonopsPicklist.masterData &&
      this.commonopsPicklist.masterData.userAuthDetails &&
      this.commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = this.commonopsPicklist.masterData.userAuthDetails.allocationRole;
      if (this.allocateRole === 'MW') {
        this.allocationType = 'MW';
      } else {
        this.allocationType = 'YL';
      }
    } else {
      this.allocationType = 'YL';
    }
  }

  /**
   * Invoked from loco context menu when allocate/de-allocate action performed.
   *
   * @private
   * @param {*} opr
   *
   * @memberof YardLocalDataComponent
   */
  private checkSuccessOperation(opr: any) {
    if (opr && opr.operation) {
      if ((opr.operation === 'allocateLocomotive' || opr.operation === 'deAllocateLocomotive') && opr.data) {
        this.isOprFromContextMenu = true;
        this.lmsLoaderService.showLoader();
        const allocateLocomotiveArr: Array<LocoDetail> = [];
        allocateLocomotiveArr.push(opr.data);
        const selectedStationLocoDetailArr: Array<StationLocoDetail> = [];
        for (let i = 0; i < allocateLocomotiveArr.length; i++) {
          const locoDetail: StationLocoDetail = {
            locomotive: this.appUtilityService.formatLocomotiveId(allocateLocomotiveArr[i].locomotiveIdentifier),
            assignedPlanned: allocateLocomotiveArr[i].assignedPlannedFlag,
            permanentTag: allocateLocomotiveArr[i].permanentTag,
            locoAllocDiv: allocateLocomotiveArr[i].locoAllocDiv,
            locoAllocStat: allocateLocomotiveArr[i].locoAllocStation,
            locoAllocType: allocateLocomotiveArr[i].locoAllocType,
            allocPermFlag: allocateLocomotiveArr[i].locoAllocPermFlag
          };
          selectedStationLocoDetailArr.push(locoDetail);
        }
        if (opr.operation === 'allocateLocomotive') {
          this.checkLocomotiveForAllocate(selectedStationLocoDetailArr);
        } else if (opr.operation === 'deAllocateLocomotive') {
          this.checkLocomotiveForDeallocate(selectedStationLocoDetailArr);
        }
      } else if (opr.operation === 'updateAllocStation' && opr.data) {
        const station: StationDetail = opr.data;
        this.openUpdateAllocationStationPopup(station);
      } else if (opr.operation === 'deleteAllocStation' && opr.data) {
        const station: StationDetail = opr.data;
        this.deleteAllocationStationName = station.allocStation;
        this.deleteAllocateStation = true;
        this.errorDialog = false;
        this.popupErrorMessage = 'Confirmation';
        this.confirmMessage = this.deleteAllocationStationName;
      }
    }
  }

  /**
   * Check locomotives for deallocate operation.
   *
   * @memberof YardLocalDataComponent
   */
  checkLocomotiveForDeallocate(selectedStationLocoDetailArr?: Array<StationLocoDetail>) {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    let unAllocatedLocoCount = 0;
    let locomotiveIds: string;
    let unAllocatedLocomotiveIds: string;
    let stationLocoDetailArr: Array<StationLocoDetail> = [];
    if (selectedStationLocoDetailArr && selectedStationLocoDetailArr.length > 0) {
      stationLocoDetailArr = selectedStationLocoDetailArr;
    } else {
      stationLocoDetailArr = this.selectedStationLocoDetailArr;
    }
    for (let i = 0; i < stationLocoDetailArr.length; i++) {
      if (!stationLocoDetailArr[i].locoAllocStat || (stationLocoDetailArr[i].locoAllocStat && stationLocoDetailArr[i].locoAllocStat.trim().length === 0)) {
        unAllocatedLocoCount++;
        if (unAllocatedLocomotiveIds) {
          unAllocatedLocomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[i].locomotive);
        } else {
          unAllocatedLocomotiveIds = this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[i].locomotive);
        }
      }
    }
    if (unAllocatedLocoCount === 0) {
      if (stationLocoDetailArr && stationLocoDetailArr.length > 0) {
        this.allocateLocomotiveArr = stationLocoDetailArr;
        for (let k = 0; k < stationLocoDetailArr.length; k++) {
          if (this.allocateRole && this.allocateRole === 'YL') {
            isLocoError = false;
          } else if (this.allocateRole && this.allocateRole === 'MW') {
            // check for allocateion, allocate role is 'MW' and permanent flag and allocation type.
            if (!stationLocoDetailArr[k].permanentTag || !stationLocoDetailArr[k].locoAllocType ||
              (stationLocoDetailArr[k].permanentTag &&
                stationLocoDetailArr[k].permanentTag.toUpperCase().trim() !== 'MW') &&
              stationLocoDetailArr[k].locoAllocType &&
              stationLocoDetailArr[k].locoAllocType.toUpperCase().trim() !== 'MW') {
              errorSelectedCount++;
              if (locomotiveIds) {
                locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[k].locomotive);
              } else {
                locomotiveIds = this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[k].locomotive);
              }
              isLocoError = true;
            }
          }
        }
        if (!isLocoError) {
          this.lmsLoaderService.hideLoader();
          this.checkPermanentAllocLocomotivesForDealloc(stationLocoDetailArr);
        } else {
          this.lmsLoaderService.hideLoader();
          if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data) {
            const messagePart = ((errorSelectedCount) === 1) ? 'is' : 'are';
            this.selectedTab.subTypeDetail.data.message = `${errorSelectedCount} out of ${stationLocoDetailArr.length} locomotives (${locomotiveIds}) ${messagePart} not allowed for this operation. `;
            this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
            this.updateTab(this.selectedTab);
          }
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data) {
        const messagePart = ((unAllocatedLocoCount) === 1) ? 'Locomotive (' + unAllocatedLocomotiveIds + ') is not currently Allocated.' : 'Locomotives (' + unAllocatedLocomotiveIds + ') are not currently Allocated.';
        this.selectedTab.subTypeDetail.data.message = 'Cannot Deallocate - ' + messagePart;
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
        this.updateTab(this.selectedTab);
      }
    }
  }

  /**
   * Check locomotives for allocate operation.
   *
   * @memberof YardLocalDataComponent
   */
  checkLocomotiveForAllocate(selectedStationLocoDetailArr?: Array<StationLocoDetail>) {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    let locomotiveIds: string;
    let stationLocoDetailArr: Array<StationLocoDetail> = [];
    if (selectedStationLocoDetailArr && selectedStationLocoDetailArr.length > 0) {
      stationLocoDetailArr = selectedStationLocoDetailArr;
    } else {
      stationLocoDetailArr = this.selectedStationLocoDetailArr;
    }
    if (stationLocoDetailArr && stationLocoDetailArr.length > 0) {
      for (let k = 0; k < stationLocoDetailArr.length; k++) {
        if (this.allocateRole && this.allocateRole === 'YL') {
          isLocoError = false;
        } else if (this.allocateRole && this.allocateRole === 'MW') {
          if (!stationLocoDetailArr[k].permanentTag || !stationLocoDetailArr[k].locoAllocType ||
            (stationLocoDetailArr[k].permanentTag &&
              stationLocoDetailArr[k].permanentTag.toUpperCase().trim() !== 'MW') &&
            stationLocoDetailArr[k].locoAllocType &&
            stationLocoDetailArr[k].locoAllocType.toUpperCase().trim() !== 'MW') {
            errorSelectedCount++;
            if (locomotiveIds) {
              locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[k].locomotive);
            } else {
              locomotiveIds = this.appUtilityService.UIformatLocomotiveId(stationLocoDetailArr[k].locomotive);
            }
            isLocoError = true;
          }
        }
      }
      if (!isLocoError) {
        this.lmsLoaderService.hideLoader();
        this.checkPermanentAllocLocomotives(stationLocoDetailArr);
      } else {
        this.lmsLoaderService.hideLoader();
        if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data) {
          const messagePart = ((errorSelectedCount) === 1) ? 'is' : 'are';
          this.selectedTab.subTypeDetail.data.message = `${errorSelectedCount} out of ${stationLocoDetailArr.length} locomotives (${locomotiveIds}) ${messagePart} not allowed for this operation. `;
          this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
          this.updateTab(this.selectedTab);
        }
      }
    }
  }
  /**
     * Check locomotives for permanent allocation'
     *
     * @memberof YardLocalDataComponent
     */
  checkPermanentAllocLocomotives(selectedStationLocoDetailArr?: Array<StationLocoDetail>) {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    this.permannentAllocMsg = '';
    if (selectedStationLocoDetailArr && selectedStationLocoDetailArr.length > 0) {
      this.allocateLocomotiveArr = selectedStationLocoDetailArr;
      let locomotiveIds = '';
      for (let k = 0; k < selectedStationLocoDetailArr.length; k++) {
        if (selectedStationLocoDetailArr[k].allocPermFlag &&
          selectedStationLocoDetailArr[k].allocPermFlag.toUpperCase().trim() === 'Y') {
          errorSelectedCount++;
          if (locomotiveIds) {
            locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(selectedStationLocoDetailArr[k].locomotive);
          } else {
            locomotiveIds = this.appUtilityService.UIformatLocomotiveId(selectedStationLocoDetailArr[k].locomotive);
          }
          isLocoError = true;
        }
      }
      if (!isLocoError) {
        this.permannentAllocDialog = false;
        this.openAllocateLocomotivePopup();
      } else {
        if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data) {
          this.permannentAllocDialog = true;
          const messagePart = ((errorSelectedCount) === 1) ? `Locomotive (${locomotiveIds}) has` : `Locomotives (${locomotiveIds}) have`;
          this.permannentAllocMsg = `${messagePart} a Permanent Allocation, Do you want to change the Allocation of the locomotive?`;
        }
      }
    }
  }

  /**
     * Check locomotives for permanent allocation'
     *
     * @memberof YardLocalDataComponent
     */
  checkPermanentAllocLocomotivesForDealloc(selectedStationLocoDetailArr?: Array<StationLocoDetail>) {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    this.permannentAllocMsg = '';
    if (selectedStationLocoDetailArr && selectedStationLocoDetailArr.length > 0) {
      this.allocateLocomotiveArr = selectedStationLocoDetailArr;
      let locomotiveIds = '';
      for (let k = 0; k < selectedStationLocoDetailArr.length; k++) {
        if (selectedStationLocoDetailArr[k].allocPermFlag &&
          selectedStationLocoDetailArr[k].allocPermFlag.toUpperCase().trim() === 'Y') {
          errorSelectedCount++;
          if (locomotiveIds) {
            locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(selectedStationLocoDetailArr[k].locomotive);
          } else {
            locomotiveIds = this.appUtilityService.UIformatLocomotiveId(selectedStationLocoDetailArr[k].locomotive);
          }
          isLocoError = true;
        }
      }
      if (!isLocoError) {
        this.permannentAllocForDeallocDialog = false;
        this.errorDialog = false;
        this.popupErrorMessage = 'Confirmation';
        this.deAllocateLocomotive = true;
      } else {
        if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data) {
          this.permannentAllocForDeallocDialog = true;
          const messagePart = ((errorSelectedCount) === 1) ? `Locomotive (${locomotiveIds}) has` : `Locomotives (${locomotiveIds}) have`;
          this.permannentAllocMsg = `${messagePart} a Permanent Allocation, Do you want to change the Allocation of the locomotive?`;
        }
      }
    }
  }

  /**
   * Destroy the state of lifecycle hook.
   * @memberof YardLocalDataComponent
   */
  ngOnDestroy() {
    this.popUpServiceSubscription.unsubscribe();
    if (this.tabStoreSubscription) {
      this.tabStoreSubscription.unsubscribe();
    }
    super.destroy();
  }

  /**
   * Invoked when cancel popup or hide popup or close popup.
   * @param {string} popupType
   * @memberof YardLocalDataComponent
   */
  cancelOperation(popupType?: string) {
    this.locoPlannedTo = 'train';
    this.allocationType = 'YL';
    this.yardLocalThpType = 'S';
    this.planLocomotive = false;
    this.searchTextTerminal = '';
    this.searchTextTrain = '';
    this.popupErrorMessage = '';
    this.searchPlanTextTerminalError = false;
    this.searchAllocationStationError = false;
    this.errorDialog = false;
    this.allocateLocomotive = false;
    this.deAllocateLocomotive = false;
    this.permanentAllocation = false;
    this.permannentAllocDialog = false;
    this.permannentAllocForDeallocDialog = false;
    this.addOrUpdateAllocationStation = false;
    this.addAllocateStation = false;
    this.updateAllocateStation = false;
    this.deleteAllocateStation = false;
    this.searchTextAllocationStation = '';
    if (popupType === 'addOrUpdateAllocationStation') {
      this.resetAddUpdateAllocationPopup();
    }
  }

  /**
   * Reset page mode when popup hide.
   * @memberof YardLocalDataComponent
   */
  resetPageMode() {
    this.setPageModeData('');
  }

  resetRuleException() {
    this.ruleException = false;
    this.isRuleExceptionSubmitEnabled = false;
  }

  cancelRuleException() {
    this.ruleException = false;
    this.planLocomotive = true;
  }

  /**
   * Reset page mode when popup show.
   * @memberof YardLocalDataComponent
   */
  setPageModeData(btnId: string, dialogId?: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
      setTimeout(() => {
        this.appUtilityService.setFocusToFirstElement(dialogId);
      }, 20);
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }
  }

  public setFocusToGivenElement(inputId: string, timeOut?: string) {
    if (inputId && inputId.length > 0) {
      if (!timeOut) {
        const input = document.getElementById(inputId);
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 20);
        }
      }
      if (timeOut) {
        setTimeout(() => {
          const input = document.getElementById(inputId);
          if (input) {
            input.focus();
          }
        }, 20);
      }
    }
  }

  /**
   * Reset Add/Update allocation station popup.
   * @memberof YardLocalDataComponent
   */
  resetAddUpdateAllocationPopup() {
    this.addDivisionName = '';
    this.addDivisionNameError = false;
    this.addAllocationStationName = '';
    this.addAllocationStationNameError = false;
    this.addRoadTerminal1 = '';
    this.addRoadTerminal1Error = false;
    this.addRoadTerminal2 = '';
    this.addRoadTerminal2Error = false;
    this.addRoadTerminal1Transit = '';
    this.addRoadTerminal1TransitError = false;
    this.addRoadTerminal2Transit = '';
    this.addRoadTerminal2TransitError = false;
    this.addSchedQMin = '';
    this.addSchedQMinError = false;
    this.addPtcFourAxleAllotmentError= false;
    this.addPtcSixAxleAllotmentError= false;
    this.addPtcRclFourAxleAllotmentError= false;
    this.addPtcRclSixAxleAllotmentError= false;
    this.addSlugAllotmentError= false;
    this.addPtcSlugAllotmentError= false;
    this.addRclFourAxleAllotmentError= false;
    this.addRclSixAxleAllotmentError= false;
    this.addPlatformError= false;
    this.addAxleFourAllotmentError= false;
    this.addAxleSixAllotmentError= false;
  }

  /**
   * Invoked for Submit popup opeation.
   * @param {string} popupType
   * @memberof YardLocalDataComponent
   */
  submitOperation(popupType: string) {
    switch (popupType) {
      case 'planLocomotive':
        this.submitPlanLocomotive();
        break;

      case 'allocateLocomotive':
        this.submitAllocateLocomotive();
        break;

      case 'addAllocateStation':
        this.submitAddAllocateStation();
        break;

      case 'updateAllocateStation':
        this.submitUpdateAllocateStation();
        break;

      case 'deleteAllocateStation':
        this.submitDeleteAllocateStation();
        break;
    }
  }

  getFormattedTrasitHours(value: string, terminal: string): string {
    if (terminal) {
      if (value && value.trim().length > 0) {
        value = value.trim();
        return this.appUtilityService.leftPad(value, '0', 3);
      }
      return '000';
    } else {
      if (value && value.trim().length > 0) {
        value = value.trim();
        return this.appUtilityService.leftPad(value, '0', 3);
      }
      return '';
    }
  }

  getFormattedSchDays(value: string): string {
    if (value && value.trim().length > 0) {
      value = value.trim();
      return this.appUtilityService.leftPad(value, '0', 2);
    }
    return '00';
  }

  /**
   * Get event for popup operation from emitter.
   * @param {any} event
   * @memberof YardLocalDataComponent
   */
  popupEventType(event) {
    this.planOptions = [];
    this.locoPlannedTo = 'train';
    switch (event) {
      case 'addAllocationStation':
        this.openAddAllocationStationPopup();
        break;
      case 'updateAllocationStation':
        this.openUpdateAllocationStationPopup();
        break;
      case 'deleteAllocationStation':
        this.errorDialog = false;
        this.deleteAllocateStation = true;
        if (this.selectedStationDetailArr && this.selectedStationDetailArr.length > 0 && this.selectedStationDetailArr[0].allocStation) {
          this.confirmMessage = this.selectedStationDetailArr[0].allocStation.toUpperCase().trim();
        }
        this.popupErrorMessage = 'Confirmation';
        break;
      case 'planLocomotiveOpr':
        this.openPlanLocomotivePopup();
        break;
      case 'allocateOpr':
        this.lmsLoaderService.showLoader();
        this.isOprFromContextMenu = false;
        this.checkLocomotiveForAllocate();
        break;
      case 'deallocateOpr':
        this.lmsLoaderService.showLoader();
        this.isOprFromContextMenu = false;
        this.checkLocomotiveForDeallocate();
        break;
    }
  }

  /*
   * Invoked when change plan option
   * @param {string} type
   * @memberof YardLocalDataComponent
   */
  changePlanOptions(type: string) {
    if (type === 'planLocomotive') {
      this.isAddTrainError = false;
      this.searchPlanTextTerminalError = false;
      this.searchTextTrain = '';
      this.yardLocalThpType = 'S';
      this.isValidThpSelection = false;
      this.searchTextTerminal = '';
      setTimeout(() => {
        if (this.locoPlannedTo && this.locoPlannedTo === 'train') {
          this.setFocusToGivenElement('yadLocalPlanTrainInp');
        } else if (this.locoPlannedTo && this.locoPlannedTo === 'terminal') {
          this.setFocusToGivenElement('yardLocalPlanTerminalInput');
        }
      }, 20);
    }
  }

  /**
   * Invoked through click on add allocation station link from other actions.
   * @memberof YardLocalDataComponent
   */
  openUpdateAllocationStationPopup(station?: StationDetail) {
    this.loadDivisionList();
    this.resetAddUpdateAllocationPopup();
    let stationDetail: StationDetail = {};
    if (station) {
      stationDetail = station;
    } else {
      if (this.selectedStationDetailArr && this.selectedStationDetailArr.length > 0 && this.selectedStationDetailArr[0].allocStation) {
        stationDetail = this.selectedStationDetailArr[0];
      }
    }
    if (stationDetail) {
      if (stationDetail.lmsDivision) {
        this.addDivisionName = stationDetail.lmsDivision.toUpperCase().trim();
      }
      if (stationDetail.allocStation) {
        this.addAllocationStationName = stationDetail.allocStation.toUpperCase().trim();
      }
      if (stationDetail.roadTerminalOne) {
        this.addRoadTerminal1 = stationDetail.roadTerminalOne.toUpperCase().trim();
      }
      if (stationDetail.roadTerminalOneTranHours) {
        this.addRoadTerminal1Transit = stationDetail.roadTerminalOneTranHours;
      }
      if (stationDetail.roadTerminalTwo) {
        this.addRoadTerminal2 = stationDetail.roadTerminalTwo.toUpperCase().trim();
      }
      if (stationDetail.roadTerminalTwoTranHours) {
        this.addRoadTerminal2Transit = stationDetail.roadTerminalTwoTranHours;
      }
      if (stationDetail.qDueScheduleDays) {
        this.addSchedQMin = stationDetail.qDueScheduleDays;
      }
      if (stationDetail.ptcFourAxleAllotment) {
        this.addPtcFourAxleAllotment = this.getIntegerVal(stationDetail.ptcFourAxleAllotment).toString();
      }
      if (stationDetail.ptcSixAxleAllotment) {
        this.addPtcSixAxleAllotment = this.getIntegerVal(stationDetail.ptcSixAxleAllotment).toString();
      }
      if (stationDetail.ptcRclFourAxleAllotment) {
        this.addPtcRclFourAxleAllotment = this.getIntegerVal(stationDetail.ptcRclFourAxleAllotment).toString();
      }
      if (stationDetail.ptcRclSixAxleAllotment) {
        this.addPtcRclSixAxleAllotment = this.getIntegerVal(stationDetail.ptcRclSixAxleAllotment).toString();
      }
      if (stationDetail.slugAllotment) {
        this.addSlugAllotment = this.getIntegerVal(stationDetail.slugAllotment).toString();
      }
      if (stationDetail.ptcSlugAllotment) {
        this.addPtcSlugAllotment = this.getIntegerVal(stationDetail.ptcSlugAllotment).toString();
      }
      if (stationDetail.rclFourAxleAllotment) {
        this.addRclFourAxleAllotment = this.getIntegerVal(stationDetail.rclFourAxleAllotment).toString();
      }
      if (stationDetail.rclSixAxleAllotment) {
        this.addRclSixAxleAllotment = this.getIntegerVal(stationDetail.rclSixAxleAllotment).toString();
      }
      if (stationDetail.platform) {
        this.addPlatform = this.getIntegerVal(stationDetail.platform).toString();
      }
      if (stationDetail.axleFourAllotment) {
        this.addAxleFourAllotment = this.getIntegerVal(stationDetail.axleFourAllotment).toString();
      }
      if (stationDetail.axleSixAllotment) {
        this.addAxleSixAllotment = this.getIntegerVal(stationDetail.axleSixAllotment).toString();
      }
    }
    this.addCityStateName = '';
    this.stateCityList = [];
    this.addAllocateStation = false;
    this.updateAllocateStation = true;
    this.addOrUpdateAllocationStation = true;
    this.errorDialog = false;
    this.popupErrorMessage = 'Update Allocation Station';
  }

  /**
   * Invoked through click on add allocation station link from other actions.
   * @memberof YardLocalDataComponent
   */
  openAddAllocationStationPopup() {
    this.loadDivisionList();
    this.resetAddUpdateAllocationPopup();
    this.addAllocationStationName = '';
    this.addDivisionName = '';
    this.addCityStateName = '';
    this.stateCityList = [];
    this.addAllocateStation = true;
    this.updateAllocateStation = false;
    this.addOrUpdateAllocationStation = true;
    this.errorDialog = false;
    this.popupErrorMessage = 'Add Allocation Station';
    if (this.selectedDivisionStation && this.selectedDivisionStation.division) {
      this.addDivisionName = this.selectedDivisionStation.division.trim().toUpperCase();
    }
  }

  /**
   * Invoked through click on plan option.
   * @memberof YardLocalDataComponent
   */
  openPlanLocomotivePopup() {
    this.searchTextTerminal = '';
    this.yardLocalThpType = 'S';
    this.searchPlanTextTerminalError = false;
    this.getLocoIncident();
    this.errorDialog = false;
    this.popupErrorMessage = 'Plan Locomotive';

    this.planOptions.push({
      label: this.dialog.planLocomotive.planOptions.train,
      value: 'train',
    });
    this.planOptions.push({
      label: this.dialog.planLocomotive.planOptions.terminal,
      value: 'terminal'
    });
  }

  /**
   * Invoked through clock on allocation option.
   * @memberof YardLocalDataComponent
   */
  openAllocateLocomotivePopup() {
    this.permannentAllocDialog = false;
    this.setAllocateRole();
    this.errorDialog = false;
    this.searchTextAllocationStation = '';
    this.searchAllocationStationError = false;
    this.permanentAllocation = false;
    this.popupErrorMessage = 'Allocate Locomotive';

    if (this.selectedStationDetailArr && this.selectedStationDetailArr.length > 0 && this.selectedStationDetailArr[0].allocStation) {
      this.searchTextAllocationStation = this.selectedStationDetailArr[0].allocStation.toUpperCase().trim();
    }
    if (this.allocateLocomotiveArr && this.allocateLocomotiveArr.length > 0) {
      this.allocateLocomotive = true;
    }
  }

  /**
   * Open De-allocate locomotive confirmation.
   * @memberof YardLocalDataComponent
   */
  openDellocateAllocateLocomotivePopup() {
    this.permannentAllocForDeallocDialog = false;
    this.errorDialog = false;
    this.popupErrorMessage = 'Confirmation';
    this.deAllocateLocomotive = true;
  }


  /**
   * Invoked for submit plan locomotive operation.
   * @memberof YardLocalDataComponent
   */
  submitPlanLocomotive() {
    this.lmsLoaderService.showLoader();
    if (this.locoPlannedTo === 'terminal') {
      if (this.searchTextTerminal && this.appUtilityService.isMnemonicExist(this.searchTextTerminal)) {
        if (this.yardLocalThpType && this.yardLocalThpType.trim().toUpperCase() === 'S') {
          if (this.appUtilityService.isValidThpSelection(this.searchTextTerminal)) {
            this.searchTextTerminal = this.searchTextTerminal.toUpperCase();
            this.submitTransferToTerminal('XSTA');
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.configData.messages.invalidThpSelection;
          }
        } else {
          this.searchTextTerminal = this.searchTextTerminal.toUpperCase();
          this.submitTransferToTerminal('XSTA');
        }
      } else {
        this.lmsLoaderService.hideLoader();
        this.searchPlanTextTerminalError = true;
      }
    } else if (this.locoPlannedTo === 'train') {
      if (this.searchTextTrain && this.appUtilityService.isValidTrainId(this.searchTextTrain)) {
        this.searchTextTrain = this.searchTextTrain.toUpperCase();
        let isNoteError = false;
        for (let p = 0; p < this.selectedLocoDetailForPlanToTrainArr.length; p++) {
          if (this.selectedLocoDetailForPlanToTrainArr[p] && this.selectedLocoDetailForPlanToTrainArr[p].intendedUsgaeNoteRequired
            && (!this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote || (this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote && this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote.length === 0))) {
            this.selectedLocoDetailForPlanToTrainArr[p].isIntendedUsageNotError = true;
            isNoteError = true;
          } else {
            if (this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote) {
              this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote = this.selectedLocoDetailForPlanToTrainArr[p].intendedUsageNote.trim().toUpperCase();
            }
            this.selectedLocoDetailForPlanToTrainArr[p].isIntendedUsageNotError = false;
          }
        }
        if (!isNoteError) {
          this.serviceCallToBre(this.searchTextTrain, this.selectedLocoDetailForPlanToTrainArr);
          this.isAddTrainError = false;
        } else {
          this.lmsLoaderService.hideLoader();
        }
      } else {
        this.lmsLoaderService.hideLoader();
        this.isAddTrainError = true;
      }
    }
  }

  /**
   * @param {string} functionCode
   *
   * @memberof YardLocalDataComponent
   */
  submitTransferToTerminal(functionCode: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    const planType = this.yardLocalThpType;
    this.createLocoTransferListForTerminal(locoTransfer, this.searchTextTerminal, planType);
    this.serviceCallLocoTransfer(locoTransfer, functionCode);
  }

  /**
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   *
   * @memberof YardLocalDataComponent
   */
  serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string) {
    this.yardLocalService.transferLocomotive(locoTransfer, operation).subscribe(
      (data) => {
        this.transferResponse = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.transferResponse.header.priorityCode)) {
          const pCode = parseInt(this.transferResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.selectedDivisionStation) {
              this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, this.transferResponse.header.messageText);
            }
            this.cancelOperation('planLocomotive');
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.transferResponse.header.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
  }

  /**
   * @param {string} trainId
   * @param {Array<String>} locoId
   *
   * @memberof YardLocalDataComponent
   */
  serviceCallToBre(trainId: string, selectedLocoDetailForPlanToTrainArr: Array<LocoDetail>) {
    const locoId: Array<String> = [];
    for (let i = 0; i < selectedLocoDetailForPlanToTrainArr.length; i++) {
      const selectedLocomotive: LocoDetail = selectedLocoDetailForPlanToTrainArr[i];
      locoId.push(this.appUtilityService.formatLocomotiveId(selectedLocomotive.locomotiveIdentifier));
    }
    this.yardLocalService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        const breTrasferParam: BreTransferAreaDetails = <BreTransferAreaDetails>data;
        if (breTrasferParam && breTrasferParam.priorityCode) {
          const pCode = parseInt(breTrasferParam.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.isLmsExceptionListExist(breTrasferParam)) {
              this.lmsLoaderService.hideLoader();
              this.ruleException = true;
              this.popupService.setPageMode('Dialog');
              this.popupService.setSubmitBtnId('ruleExceptionLocoData');

              const newLmsExceptionList: Array<LmsException> = [];
              for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
                const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
                const locoObj: LocoDetail = this.getLocoObjById(lmsException.locoId, selectedLocoDetailForPlanToTrainArr);
                if (locoObj) {
                  lmsException.intendedUsageDesc = this.appUtilityService.getIntendedUsageDesc(locoObj.intendedUsageCode);
                  lmsException.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(locoObj.intendedUsageReason);
                  lmsException.intendedUsageNote = locoObj.intendedUsageNote;
                }
                lmsException.isSelectedLoco = false;
                newLmsExceptionList.push(lmsException);
              }
              this.lmsExceptionList = newLmsExceptionList;

              const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
                return lmsException.isSelectedLoco;
              });
              if (checkedExceptionList && checkedExceptionList.length > 0) {
                this.isRuleExceptionSubmitEnabled = true;
              }
            } else {
              const locoTransfer: Array<LocoTransfer> = [];
              this.createLocoTransferListForTrain(locoTransfer, trainId);
              if (this.planLocomotive) {
                this.serviceCallLocoTransfer(locoTransfer, 'XTRN');
              }
            }
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = breTrasferParam.messageText;
          }
        }

      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      }
    );
  }

  getLocoObjById(locoId: string, locoArr: Array<LocoDetail>): LocoDetail {
    for (let x = 0; x < locoArr.length; x++) {
      const oldLocoId = this.appUtilityService.UIformatLocomotiveId(locoId);
      const newLocoId = this.appUtilityService.UIformatLocomotiveId(locoArr[x].locomotiveIdentifier);
      if (oldLocoId && newLocoId && oldLocoId.trim().toUpperCase() === newLocoId.trim().toUpperCase()) {
        return locoArr[x];
      }
    }
  }

  /**
   * @param {Array<StationLocoDetail>} locoTransfer
   * @param {string} trainsId
   *
   * @memberof YardLocalDataComponent
   */
  createLocoTransferListForTrain(locoTransfer: Array<LocoTransfer>, trainsId: string) {
    for (let i = 0; i < this.selectedLocoDetailForPlanToTrainArr.length; i++) {
      const selectedLocomotive = this.selectedLocoDetailForPlanToTrainArr[i];
      const a = {
        currentTerminalIdentifier: selectedLocomotive.plannedOrCurrentLoc, // To be To be verified
        trainIdentifier: trainsId,
        terminalHandlingType: this.yardLocalThpType,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocomotive.locomotiveIdentifier),
          qualifier: selectedLocomotive.qualifier,
          assignedOrPlanned: selectedLocomotive.assignedPlannedFlag,
          intendedUsageCode: selectedLocomotive.intendedUsageCode,
          intendedUsageReason: selectedLocomotive.intendedUsageReason,
          intendedUsageNotes: selectedLocomotive.intendedUsageNote
        }
      };
      locoTransfer.push(a);
    }
  }

  /**
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   *
   * @memberof YardLocalDataComponent
   */
  createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string) {
    for (let i = 0; i < this.selectedStationLocoDetailArr.length; i++) {
      const stationLocoDetail: StationLocoDetail = this.selectedStationLocoDetailArr[i];
      const a = {
        currentTerminalIdentifier: stationLocoDetail.planCurrLoc, // To be To be verified
        terminalIdentifier: terminal,
        terminalHandlingType: terminalType,
        locoTransferList: {
          locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(stationLocoDetail.locomotive),
          qualifier: stationLocoDetail.qualifier,
          assignedOrPlanned: stationLocoDetail.assignedPlanned
        }
      };
      locoTransfer.push(a);
    }
  }

  /**
   * @param {BreTransferAreaDetails} breTrasferParam
   * @returns {boolean}
   *
   * @memberof YardLocalDataComponent
   */
  isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Submit deallocate locomotive.
   * @memberof YardLocalDataComponent
   */
  submitDeallocateLocomotives() {
    this.lmsLoaderService.showLoader();
    const allocDeallocData = this.buildRequestParamForDeallocate();
    this.yardLocalService.deAllocateLocomotives(allocDeallocData).subscribe(data => {
      this.responseHeader = <Header>data;
      if (this.responseHeader && this.responseHeader.priorityCode) {
        const pCode = parseInt(this.responseHeader.priorityCode, 10);
        if (pCode >= 1 && pCode <= 4) {
          this.popupErrorMessage = 'Confirmation';
          this.errorDialog = false;
          this.deAllocateLocomotive = false;
          this.lmsLoaderService.hideLoader();
          if (this.selectedDivisionStation) {
            if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption) {
              this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, '', true, this.responseHeader.messageText);
            } else {
              this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, this.responseHeader.messageText);
            }
          }
        } else {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popupErrorMessage = this.responseHeader.messageText;
        }
      }
    }, error => {
      this.lmsLoaderService.hideLoader();
      this.errorDialog = true;
      this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
    });
  }

  /**
   * Request param for de-allocate locomotives.
   * @returns {AllocDeallocData}
   * @memberof YardLocalDataComponent
   */
  buildRequestParamForDeallocate(): AllocDeallocData {
    const allocateLocomotiveArr: Array<LocoDetail> = [];
    for (let i = 0; i < this.allocateLocomotiveArr.length; i++) {
      const locoDetail: LocoDetail = {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.allocateLocomotiveArr[i].locomotive),
        assignedPlannedFlag: this.allocateLocomotiveArr[i].assignedPlanned
      };
      allocateLocomotiveArr.push(locoDetail);
    }
    const allocDeallocData: AllocDeallocData = {
      allocationStation: this.searchTextAllocationStation,
      allocationType: this.allocationType,
      permanentAllocation: this.permanentAllocation ? 'Y' : 'N',
      allocationRole: this.allocateRole,
      locoDataList: allocateLocomotiveArr
    };
    return allocDeallocData;
  }

  /**
   * Invoked for submit allocate locomotive operation.
   * @memberof YardLocalDataComponent
   */
  submitAllocateLocomotive() {
    this.searchAllocationStationError = false;
    this.lmsLoaderService.showLoader();
    if (this.searchTextAllocationStation && this.appUtilityService.isAllocationStationExist(this.searchTextAllocationStation)) {
      const allocDeallocData = this.buildRequestParamForAllocate();
      this.yardLocalService.allocateLocomotives(allocDeallocData).subscribe(data => {
        this.responseHeader = <Header>data;
        if (this.responseHeader && this.responseHeader.priorityCode) {
          const pCode = parseInt(this.responseHeader.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.lmsLoaderService.hideLoader();
            this.allocateLocomotive = false;
            if (this.selectedDivisionStation) {
              if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption) {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, '', true, this.responseHeader.messageText);
              } else {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, this.responseHeader.messageText);
              }
            }
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.responseHeader.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    } else {
      this.lmsLoaderService.hideLoader();
      this.searchAllocationStationError = true;
    }
  }

  /**
   * Request param for allocate locomotives.
   * @returns {AllocDeallocData}
   * @memberof YardLocalDataComponent
   */
  buildRequestParamForAllocate(): AllocDeallocData {
    const locoDataList: Array<LocoDetail> = [];
    for (let i = 0; i < this.allocateLocomotiveArr.length; i++) {
      const locoDetail: LocoDetail = {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.allocateLocomotiveArr[i].locomotive),
        assignedPlannedFlag: this.allocateLocomotiveArr[i].assignedPlanned
      };
      locoDataList.push(locoDetail);
    }

    const allocDeallocData: AllocDeallocData = {
      allocationStation: this.searchTextAllocationStation.toUpperCase().trim(),
      allocationType: this.allocationType,
      permanentAllocation: this.permanentAllocation ? 'Y' : 'N',
      allocationRole: this.allocateRole,
      locoDataList: locoDataList
    };
    return allocDeallocData;
  }

  /**
   * Invoked for submit add allocate station.
   * @memberof YardLocalDataComponent
   */
  submitAddAllocateStation() {
    if (this.isValidAddAllocationStationForm()) {
      this.lmsLoaderService.showLoader();
      const yardAndLocalRequest: YardAndLocalRequest = {
        division: this.addDivisionName.toUpperCase(),
        allocationStation: this.addAllocationStationName.toUpperCase(),
        fourAxleAllotment: this.addAxleFourAllotment, // this value is fixed
        sixAxleAllotment: this.addAxleSixAllotment,
        rclFourAxleAllotment: this.addRclFourAxleAllotment,
        rclSixAxleAllotment: this.addRclSixAxleAllotment,
        platform: this.addPlatform,
        slug: this.addSlugAllotment,
        ptcFourAxleAllotment: this.addPtcFourAxleAllotment,
        ptcSixAxleAllotment: this.addPtcSixAxleAllotment,
        ptcRclFourAxleAllotment: this.addPtcRclFourAxleAllotment,
        ptcRclSixAxleAllotment: this.addPtcRclSixAxleAllotment,
        ptcSlugAllotment: this.addPtcSlugAllotment,
        roadTerminal1: this.addRoadTerminal1.toUpperCase(),
        roadTerminal2: this.addRoadTerminal2.toUpperCase(),
        roadTerminal1TransitHours: this.getFormattedTrasitHours(this.addRoadTerminal1Transit, this.addRoadTerminal1),
        roadTerminal2TransitHours: this.getFormattedTrasitHours(this.addRoadTerminal2Transit, this.addRoadTerminal2),
        schedulingQDue: this.getFormattedSchDays(this.addSchedQMin)
      };
      this.yardLocalService.addAllocationStation(yardAndLocalRequest).subscribe(data => {
        this.lmsLoaderService.hideLoader();
        if (data && data.priorityCode) {
          const pCode = parseInt(data.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.addOrUpdateAllocationStation = false;

            if (this.selectedDivisionStation) {
              if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption) {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, '', true, data.messageText);
              } else {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, data.messageText);
              }
            } else {
              this.messageHandlerService.handleMessage(<MessageDetails>({
                type: this.configService.getConfigData().message.type.server,
                level: this.configService.getConfigData().message.level.success,
                target: this.configService.getConfigData().message.target.page,
                message: data.messageText
              }));
            }
          } else {
            this.errorDialog = true;
            this.popupErrorMessage = data.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    }
  }

  /**
   * Invoked for submit update allocate station.
   * @memberof YardLocalDataComponent
   */
  submitUpdateAllocateStation() {
    if (this.isValidAddAllocationStationForm()) {
      this.lmsLoaderService.showLoader();
      const yardAndLocalRequest: YardAndLocalRequest = {
        division: this.addDivisionName.toUpperCase(),
        allocationStation: this.addAllocationStationName.toUpperCase(),
        fourAxleAllotment: this.addAxleFourAllotment, // this value is fixed
        sixAxleAllotment: this.addAxleSixAllotment,
        rclFourAxleAllotment: this.addRclFourAxleAllotment,
        rclSixAxleAllotment: this.addRclSixAxleAllotment,
        platform: this.addPlatform,
        slug: this.addSlugAllotment,
        ptcFourAxleAllotment: this.addPtcFourAxleAllotment,
        ptcSixAxleAllotment: this.addPtcSixAxleAllotment,
        ptcRclFourAxleAllotment: this.addPtcRclFourAxleAllotment,
        ptcRclSixAxleAllotment: this.addPtcRclSixAxleAllotment,
        ptcSlugAllotment: this.addPtcSlugAllotment,
        roadTerminal1: this.addRoadTerminal1.toUpperCase(),
        roadTerminal2: this.addRoadTerminal2.toUpperCase(),
        roadTerminal1TransitHours: this.getFormattedTrasitHours(this.addRoadTerminal1Transit, this.addRoadTerminal1),
        roadTerminal2TransitHours: this.getFormattedTrasitHours(this.addRoadTerminal2Transit, this.addRoadTerminal2),
        schedulingQDue: this.getFormattedSchDays(this.addSchedQMin)
      };
      this.yardLocalService.updateAllocationStation(yardAndLocalRequest).subscribe(data => {
        this.lmsLoaderService.hideLoader();
        if (data && data.priorityCode) {
          const pCode = parseInt(data.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.addOrUpdateAllocationStation = false;
            if (this.selectedDivisionStation) {
              if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption) {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, '', true, data.messageText);
              } else {
                this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, data.messageText);
              }
            } else {
              this.messageHandlerService.handleMessage(<MessageDetails>({
                type: this.configService.getConfigData().message.type.server,
                level: this.configService.getConfigData().message.level.success,
                target: this.configService.getConfigData().message.target.page,
                message: data.messageText
              }));
            }
          } else {
            this.errorDialog = true;
            this.popupErrorMessage = data.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    }
  }

  /**
   * Submit action for delete allocation station.
   * @memberof YardLocalDataComponent
   */
  submitDeleteAllocateStation() {
    this.lmsLoaderService.showLoader();
    let divisionName = ''; let stationName = '';
    if (this.deleteAllocationStationName) {
      stationName = this.deleteAllocationStationName.toUpperCase().trim();
    } else {
      if (this.selectedStationDetailArr && this.selectedStationDetailArr.length > 0 && this.selectedStationDetailArr[0].allocStation) {
        stationName = this.selectedStationDetailArr[0].allocStation.toUpperCase().trim();
      }
    }
    if (this.selectedDivisionStation) {
      divisionName = this.selectedDivisionStation.division;
    }
    this.yardLocalService.deleteAllocationStation(divisionName, stationName).subscribe(data => {
      this.lmsLoaderService.hideLoader();
      this.popupErrorMessage = '';
      if (data && data.priorityCode) {
        const pCode = parseInt(data.priorityCode, 10);
        if (pCode >= 1 && pCode <= 4) {
          this.deleteAllocateStation = false;
          this.deleteAllocationStationName = '';
          if (this.selectedDivisionStation) {
            if (this.yardLocalSubHeader && this.yardLocalSubHeader.yardLocalOption) {
              this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, '', true, data.messageText);
            } else {
              this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, 'Y', '', true, data.messageText);
            }
          } else {
            this.messageHandlerService.handleMessage(<MessageDetails>({
              type: this.configService.getConfigData().message.type.server,
              level: this.configService.getConfigData().message.level.success,
              target: this.configService.getConfigData().message.target.page,
              message: data.messageText
            }));
          }
        } else {
          this.errorDialog = true;
          this.popupErrorMessage = data.messageText;
        }
      }
    }, error => {
      this.lmsLoaderService.hideLoader();
      this.errorDialog = true;
      this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
    });
  }

  /**
   * Fetch allocation stations and city, state.
   * @memberof YardLocalDataComponent
   */
  fetchAllocationStations() {
    this.stateCityList = [];
    if (this.addDivisionName && this.addAllocationStationName) {
      this.addAllocationStationNameError = false;
      this.lmsLoaderService.showLoader();
      this.yardLocalService.getAllocationStations(this.addDivisionName, this.addAllocationStationName).subscribe(data => {
        this.lmsLoaderService.hideLoader();
        const stationCityStateArr: Array<StationCityState> = data.yardAndLocalListType;
        for (let i = 0; i < stationCityStateArr.length; i++) {
          this.stateCityList.push({
            label: stationCityStateArr[i].allocationStation + '  ' + stationCityStateArr[i].city + '  ' + stationCityStateArr[i].state,
            value: stationCityStateArr[i].allocationStation
          });
        }
        if (this.stateCityList && this.stateCityList.length > 0) {
          this.addAllocationStationNameError = false;
          this.addAllocationStationName = this.stateCityList[0].value;
          if (this.addAllocateStation) {
            this.errorDialog = false;
            this.popupErrorMessage = 'Add Allocation Station';
          }
        } else {
          this.errorDialog = true;
          this.popupErrorMessage = data.messageText;
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    } else {
      if (!this.addDivisionName) {
        this.addDivisionNameError = true;
      } else {
        this.addDivisionNameError = false;
      }
      if (!this.addAllocationStationName) {
        this.addAllocationStationNameError = true;
      } else {
        this.addAllocationStationNameError = false;
      }
    }
  }

  /**
   * Invoked when change value in division dropdown.
   * @memberof YardLocalDataComponent
   */
  changeDivisionName() {
    if (this.addDivisionName) {
      this.addDivisionNameError = false;
    } else {
      this.addDivisionNameError = true;
    }
  }
  /**
   * Change value from city/state dropdown.
   * @memberof YardLocalDataComponent
   */
  cityStateChange() {
    this.addAllocationStationName = this.addCityStateName;
  }

  /**
   * Autoomplete for allocation station.
   *
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  autoCompleteForAllocationStation(event) {
    this.filteredResults = [];
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      this.allocationStationArr = this.commonopsPicklist.masterData.allocationStationList;
      for (const allocStation of this.allocationStationArr) {
        this.filteredResults.push(allocStation.allocationStation);
      }
      this.filteredResults = this.filteredResults.filter((s) => {
        return s.startsWith(event.query.toUpperCase());
      });
      this.filteredResults.sort();
    }

  }

  /**
   * Invoked when select value from station autocomplete.
   *
   * @param {string} value
   *
   * @memberof YardLocalDataComponent
   */
  selectValueFromStationAutoComplete(value: string) {
    if (value) {
      this.searchAllocationStationError = false;
      this.searchTextAllocationStation = value;
    }
  }

  /**
   * Autocomplete for terminal mnemonic.
   *
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.mapOfMnemonis) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));

    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * @param {string} value
   *
   * @memberof YardLocalDataComponent
   */
  selectValueFromAutoComplete(value: string) {
    this.searchPlanTextTerminalError = false;
    let emitValue = value;
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.mapOfMnemonis) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.searchTextTerminal = emitValue;
    if (this.planLocomotive && !this.appUtilityService.isValidThpSelection(this.searchTextTerminal)) {
      this.yardLocalThpType = 'M';
      this.isValidThpSelection = true;
    } else {
      this.yardLocalThpType = 'S';
      this.isValidThpSelection = false;
    }
  }

  /**
   * @param {string} value
   *
   * @memberof YardLocalDataComponent
   */
  selectValueForRoadTerminal1(value: string) {
    let emitValue = value;
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.mapOfMnemonis) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.addRoadTerminal1 = emitValue;
    if (this.addRoadTerminal1) {
      this.addRoadTerminal1Error = false;
    }
  }

  /**
   * @param {string} value
   *
   * @memberof YardLocalDataComponent
   */
  selectValueForRoadTerminal2(value: string) {
    let emitValue = value;
    if (this.commonopsPicklist) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.addRoadTerminal2 = emitValue;
    if (this.addRoadTerminal2) {
      this.addRoadTerminal2Error = false;
    }
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  loadYardLocalDataEvent(event) {
    this.setDefaultGridFilter();
    if (!this.yardLocalSubHeader) {
      this.setYardLocalSubHeader('Y', false, true);
    }
    if (event && event.division && event.allocationStation) {
      let includeSpecialAlloc = '';
      if (this.yardLocalSubHeader.isIncludeSpecialAllocation) {
        includeSpecialAlloc = 'Y';
      }
      this.selectedDivisionStation = {
        division: event.division,
        allocationStation: event.allocationStation
      };
      // this.loadDataFromService(event.division, event.allocationStation, this.yardLocalSubHeader.yardLocalOption, includeSpecialAlloc, false);
    } else if (event && event.opr && event.opr === 'refresh' && this.selectedDivisionStation && this.selectedDivisionStation.division && this.selectedDivisionStation.allocationStation) {
      let includeSpecialAlloc = '';
      if (this.yardLocalSubHeader.isIncludeSpecialAllocation) {
        includeSpecialAlloc = 'Y';
      }
      // this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, this.yardLocalSubHeader.yardLocalOption, includeSpecialAlloc, false);
    } else {
      this.allStationDetailArr = [];
      this.stationDetailArr = [];
      this.isLoaded = false;
      if (this.yardLocalDetail) {
        this.yardLocalDetail.isLoaded = false;
      }
      this.selectedDivisionStation = {
        division: event.division,
        allocationStation: event.allocationStation
      };
      // this.updateDataStore();
    }
  }

  /**
   * @param {Array<StationDetail>} responseStationLocoDetailArr
   * @returns {Array<StationLocoDetail>}
   *
   * @memberof YardLocalDataComponent
   */
  setStationLocomotiveMapping(responseStationLocoDetailArr: Array<StationDetail>, locoId?: string): Array<StationLocoDetail> {

    const stationLocoDetailArr: Array<StationLocoDetail> = [];
    for (let i = 0; i < responseStationLocoDetailArr.length; i++) {
      const stationDetail: StationDetail = responseStationLocoDetailArr[i];
      const stDetail: StationDetail = JSON.parse(JSON.stringify(stationDetail));
      if (stDetail && stDetail.listOfLocomotives && stDetail.listOfLocomotives.length > 0) {
        for (let j = 1; j <= 6; j++) {
          const stDetailMain: StationDetail = JSON.parse(JSON.stringify(stationDetail));
          const listOfLocomotive = this.getStationLocoDetailDisplayRow(j, stDetailMain, locoId);
          if (listOfLocomotive.length > 0) {
            stDetailMain.stationRowNum = j;
            stDetailMain.listOfLocomotives = listOfLocomotive;
            stationLocoDetailArr.push(stDetailMain);
          } else {
            if (j === 1 && stDetailMain && stDetailMain.allocStation !== 'OTHMOW') {
              stDetailMain.stationRowNum = j;
              stDetailMain.listOfLocomotives = [];
              stationLocoDetailArr.push(stDetailMain);
            }
          }
        }
      } else {
        stDetail.stationRowNum = 1;
        stationLocoDetailArr.push(stDetail);
      }
    }
    return stationLocoDetailArr;
  }

  /**
   * @param {number} displayRow
   * @param {StationDetail} stationDetail
   * @returns {Array<StationLocoDetail>}
   *
   * @memberof YardLocalDataComponent
   */
  getStationLocoDetailDisplayRow(displayRow: number, stationDetail: StationDetail, loco?: string): Array<StationLocoDetail> {
    const stationLocoDetailArr: Array<StationLocoDetail> = [];
    for (let j = 0; j < stationDetail.listOfLocomotives.length; j++) {
      if (stationDetail.listOfLocomotives[j].displayRow && !isNaN(Number(stationDetail.listOfLocomotives[j].displayRow))) {
        if (Number(stationDetail.listOfLocomotives[j].displayRow) === displayRow) {
          if (stationDetail && stationDetail.listOfLocomotives[j] && stationDetail.listOfLocomotives[j].locomotive) {
            if (loco && (this.appUtilityService.UIformatLocomotiveId(loco) === this.appUtilityService.UIformatLocomotiveId(stationDetail.listOfLocomotives[j].locomotive))) {
              stationDetail.listOfLocomotives[j].isLocoHighlighted = true;
            } else {
              stationDetail.listOfLocomotives[j].isLocoHighlighted = false;
            }
          }
          stationLocoDetailArr.push(stationDetail.listOfLocomotives[j]);
        }
      }
    }
    return stationLocoDetailArr;
  }

  /**
   * @param {Array<StationDetail>} stationDetailArr
   * @returns {Array<StationDetail>}
   *
   * @memberof YardLocalDataComponent
   */
  setTotalLineValues(stationDetailArr: Array<StationDetail>): Array<StationDetail> {
    stationDetailArr.forEach((stationDetail) => {
      const totalLine = stationDetail.totalLine;
      if (totalLine && _.split(totalLine, ':').length >= 2) {
        const totalLineArr = _.split(_.split(totalLine, ':')[1], ',');
        for (let i = 0; i < totalLineArr.length; i++) {
          const a = _.split(totalLineArr[i], '=');
          if (a[0] && a[0].trim() === 'Net Alloc') {
            stationDetail.netAlloc = a[1];
            const netAllocArr = a[1].split('(');
            if (netAllocArr && netAllocArr.length > 0) {
              stationDetail.netAllocValue = netAllocArr[0];
            } else {
              stationDetail.netAllocValue = a[1];
            }
          }
          if (a[0] && a[0].trim() === 'Avail vs. Plan') {
            stationDetail.availVsPlan = a[1];
          }
        }
      }
    });
    return stationDetailArr;
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  allocStationTypeEvent(event) {
    this.isPlanButtonEnabled = false;
    this.isAllocateButtonEnabled = false;
    this.isDeAllocateButtonEnabled = false;
    if (event && event.yardLocalOption) {
      this.setYardLocalSubHeader(event.yardLocalOption, event.isIncludeSpecialAllocation, true);
      if (this.selectedDivisionStation) {
        let includeSpAlloc = '';
        if (event.isIncludeSpecialAllocation) {
          includeSpAlloc = 'Y';
        }
      }
    }
  }


  /**
    * @param {any} event
    *
    * @memberof YardLocalDataComponent
    */
  allocStationSearchYardLocalEvent(event) {
    this.isPlanButtonEnabled = false;
    this.isAllocateButtonEnabled = false;
    this.isDeAllocateButtonEnabled = false;
    if (event && event.yardLocalOption) {
      this.setYardLocalSubHeader(event.yardLocalOption, event.isIncludeSpecialAllocation);
      if (this.selectedDivisionStation) {
        let includeSpAlloc = '';
        if (event.isIncludeSpecialAllocation) {
          includeSpAlloc = 'Y';
        }
        this.loadDataFromService(this.selectedDivisionStation.division, this.selectedDivisionStation.allocationStation, event.yardLocalOption, includeSpAlloc, false);
      }
    }
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  locoStationSelectionEvent(event: Array<StationDetail>) {
    if (event) {
      this.setAllocateRole(); // if allocation role is not set from common picklist.
      const stationDetailArr: Array<StationDetail> = JSON.parse(JSON.stringify(event));
      this.selectedStationDetailArr = [];
      this.selectedStationLocoDetailArr = [];
      this.selectedLocoDetailForPlanToTrainArr = [];
      const locoDetailArr: Array<StationDetail> = JSON.parse(JSON.stringify(this.stationDetailArr));
      this.selectedStationDetailArr = _.filter(locoDetailArr, function (stationDetail) {
        return stationDetail.isStationSelected;
      });

      for (let i = 0; i < locoDetailArr.length; i++) {
        for (let j = 0; j < locoDetailArr[i].listOfLocomotives.length; j++) {
          if (locoDetailArr[i].listOfLocomotives[j].isLocoSelected) {
            this.selectedStationLocoDetailArr.push(locoDetailArr[i].listOfLocomotives[j]);
            this.selectedLocoDetailForPlanToTrainArr.push(this.convertStationLocoToLocoDetail(locoDetailArr[i].listOfLocomotives[j]));
          }
        }
      }
      if (this.selectedStationDetailArr && this.selectedStationDetailArr.length > 0) {
        this.isStationIconSelected = true;
      } else {
        this.isStationIconSelected = false;
      }

      if (this.selectedStationLocoDetailArr && this.selectedStationLocoDetailArr.length > 0) {
        this.setAllocateDellocateBtnState();
        this.isPlanButtonEnabled = true;
      } else {
        this.isDeAllocateButtonEnabled = false;
        this.isAllocateButtonEnabled = false;
        this.isPlanButtonEnabled = false;
      }

      this.updateDataStore();
    }
  }

  /**
   * Set state of allocate and de-allocate button
   * @memberof YardLocalDataComponent
   */
  setAllocateDellocateBtnState() {
    if (this.allocateRole && (this.allocateRole === 'YL' || this.allocateRole === 'MW')) {
      this.isAllocateButtonEnabled = true;
      this.isDeAllocateButtonEnabled = true;
    } else {
      this.isAllocateButtonEnabled = false;
      this.isDeAllocateButtonEnabled = false;
    }
  }

  /**
   * @memberof YardLocalDataComponent
   */
  public updateDataStore() {
    setTimeout(() => {
      if (this.selectedTab) {
        this.dataStoreService.removeTab(this.selectedTab);
        const tabData = <TabData>({
          id: this.selectedTab.id,
          subType: this.selectedTab.subType
        });
        tabData.data = tabData.data ? tabData.data : {};
        this.yardLocalDetail = {
          divisionStation: this.selectedDivisionStation,
          yardLocalSubHeader: this.yardLocalSubHeader,
          allStationDetailArr: this.allStationDetailArr,
          stationDetailArr: this.stationDetailArr,
          lasteRefreshedTime: this.lasteRefreshedTime,
          isLoaded: this.isLoaded,
          selectedSortBy: this.selectedSortBy,
          selectedAlphaSortType: this.selectedAlphaSortType,
          selectedNetAllocSortType: this.selectedNetAllocSortType,
          selectedExtraPowerSortType: this.selectedExtraPowerSortType
        };
        tabData.data[this.selectedTab.subType] = this.yardLocalDetail;
        this.dataStoreService.putValue(this.selectedTab, tabData);
      }
    }, 50);
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  showLocoContextMenu(event) {
    this.hideContextMenuChild();
    setTimeout(() => {
      if (event && event.loco) {
        event.loco.allocateRole = this.allocateRole;
      }
      this.selectedLoco = event.loco;
      this.selectedLocoId = event.locoId;
      this.selectedLoco.renderContextMenu = true;
    }, 5);
  }

  /**
   * @memberof YardLocalDataComponent
   */
  @HostListener('document:click') hideContextMenuChild() {
    super.hideContextMenu('host');
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalDataComponent
   */
  showStationContextMenu(event) {
    this.hideContextMenu('station');
    setTimeout(() => {
      this.selectedStation = event.stationDetail;
      this.selectedStationId = event.stationId;
    }, 5);
  }

  /**
   * @param {string} division
   * @param {string} allocationStation
   * @param {string} stTypeCode
   * @param {string} includeSpAlloc
   * @param {boolean} isFromOtherOperation
   * @param {string} [messageText]
   *
   * @memberof YardLocalDataComponent
   */
  loadDataFromService(division: string, allocationStation: string, stTypeCode: string, includeSpAlloc: string, isFromOtherOperation: boolean, messageText?: string, loco?: string) {
    if ((stTypeCode && 'M' !== stTypeCode) && (division && 'ALLMOW' === division)) {
      division = '';
    }
    const locateLocoId = this.locateLocoId;
    this.locateLocoId = null;
    if (division) {
      this.yardLocalService.getData(division, allocationStation, stTypeCode, includeSpAlloc).subscribe(data => {
        this.isPlanButtonEnabled = false;
        this.isAllocateButtonEnabled = false;
        this.isDeAllocateButtonEnabled = false;
        this.isStationIconSelected = false;
        this.lasteRefreshedTime = data.refreshTime;
        this.isLoaded = true;
        this.lmsLoaderService.hideLoader();
        const responseStationLocoDetailArr: Array<StationDetail> = this.setTotalLineValues(data.yardLocalStationList);
        this.allStationDetailArr = this.setStationLocomotiveMapping(responseStationLocoDetailArr, locateLocoId);
        this.allStationDetailArr.sort(this.alphabeticByStationAscCompare);
        if (this.yardLocalSubHeader) {
          if (this.yardLocalSubHeader.yardLocalOption === 'S') {
            this.allStationDetailArr = this.allStationDetailArr.filter((stationDetail) => {
              return stationDetail.stationRowNum !== 1;
            });
          }
        } else {
          this.yardLocalSubHeader = {
            yardLocalOption: stTypeCode
          };
        }
        this.stationDetailArr = JSON.parse(JSON.stringify(this.allStationDetailArr));
        this.selectedDivisionStation = {
          division: division,
          allocationStation: allocationStation
        };
        this.updateDataStore();
        if (this.selectedTab) {
          this.selectedTab.lastRefreshTime = this.lasteRefreshedTime;
          this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.loaded;
          this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].message = '';
          this.selectedTab.description = division + ' - ' + allocationStation;
          this.updateTab(this.selectedTab);
        }
        if (isFromOtherOperation && messageText) {
          this.isPlanButtonEnabled = false;
          this.isAllocateButtonEnabled = false;
          this.isDeAllocateButtonEnabled = false;
          this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configService.getConfigData().message.type.server,
            level: this.configService.getConfigData().message.level.success,
            target: this.configService.getConfigData().message.target.page,
            message: messageText
          }));
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        if (this.selectedTab) {
          this.selectedTab.subTypeDetail.data.message = this.appUtilityService.getHttpErroMessage(error, false);
          this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.error;
          this.updateTab(this.selectedTab);
        }
      });
    } else {
      this.openDefaultYardLocal();
    }
  }

  alphabeticByStationAscCompare(stationDetailA: StationDetail, stationDetailB: StationDetail) {
    if (stationDetailA.allocStation < stationDetailB.allocStation) {
      return -1;
    }
    if (stationDetailA.allocStation > stationDetailB.allocStation) {
      return 1;
    }
    return 0;
  }

  /**
   * Clear yard and local and open default view.
   *
   * @memberof YardLocalDataComponent
   */
  openDefaultYardLocal() {
    this.allStationDetailArr = [];
    this.stationDetailArr = [];
    this.isLoaded = false;
    if (this.yardLocalDetail) {
      this.yardLocalDetail.isLoaded = false;
    }
    this.selectedDivisionStation = {
      division: '',
      allocationStation: 'all'
    };
    this.setDefaultGridFilter();
    this.updateDataStore();
  }

  /**
   * Set Default values for grid filters
   * @memberof YardLocalDataComponent
   */
  setDefaultGridFilter() {
    this.selectedSortBy = 'alphabeticByDivision';
    this.selectedAlphaSortType = 'asc';
    this.selectedNetAllocSortType = 'asc';
    this.selectedExtraPowerSortType = 'desc';
  }

  /**
   * Set Yard and local sub header data.
   * @param {string} yardLocalOption
   * @param {boolean} isIncludeSpecialAllocation
   * @memberof YardLocalDataComponent
   */
  setYardLocalSubHeader(yardLocalOption: string, isIncludeSpecialAllocation: boolean, notUpdateDataStore?: boolean) {
    this.yardLocalSubHeader = {
      yardLocalOption: yardLocalOption,
      isIncludeSpecialAllocation: isIncludeSpecialAllocation,
    };
    if (!this.yardLocalDetail) {
      this.yardLocalDetail = {
        yardLocalSubHeader: this.yardLocalSubHeader
      };
    } else {
      this.yardLocalDetail.yardLocalSubHeader = this.yardLocalSubHeader;
    }
    if (!notUpdateDataStore) {
      this.updateDataStore();
    }
  }

  /**
   * Clear error message.
   * @param {any} event
   * @memberOf YardLocalDataComponent
   */
  clearErrorMessage(event) {
    if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data && this.selectedTab.subTypeDetail.data.message) {
      this.selectedTab.subTypeDetail.data.message = '';
      this.updateTab(this.selectedTab);
    }
  }

  /**
   * Validate Add/Update Allocation Station Form.
   * @returns {boolean}
   * @memberof YardLocalDataComponent
   */
  isValidAddAllocationStationForm(): boolean {
    let flag = true;
    this.addDivisionNameError = false;
    this.addAllocationStationNameError = false;
    this.addRoadTerminal1Error = false;
    this.addRoadTerminal1TransitError = false;
    this.addSchedQMinError = false;
    this.addPtcFourAxleAllotmentError= false;
    this.addPtcSixAxleAllotmentError= false;
    this.addPtcRclFourAxleAllotmentError= false;
    this.addPtcRclSixAxleAllotmentError= false;
    this.addSlugAllotmentError= false;
    this.addPtcSlugAllotmentError= false;
    this.addRclFourAxleAllotmentError= false;
    this.addRclSixAxleAllotmentError= false;
    this.addPlatformError= false;
    this.addAxleFourAllotmentError= false;
    this.addAxleSixAllotmentError= false;

    if (!this.addDivisionName || (this.addDivisionName && this.addDivisionName.trim().length === 0)) {
      flag = false;
      this.addDivisionNameError = true;
    }
    if (!this.addAllocationStationName || (this.addAllocationStationName && this.addAllocationStationName.trim().length === 0)) {
      flag = false;
      this.addAllocationStationNameError = true;
    }
    if (!this.appUtilityService.isMnemonicExist(this.addRoadTerminal1)) {
      flag = false;
      this.addRoadTerminal1Error = true;
    }
    if (!this.addRoadTerminal1Transit || (this.addRoadTerminal1Transit && this.addRoadTerminal1Transit.trim().length === 0)) {
      flag = false;
      this.addRoadTerminal1TransitError = true;
    }
    if (!this.addSchedQMin || (this.addSchedQMin && this.addSchedQMin.trim().length === 0)) {
      flag = false;
      this.addSchedQMinError = true;
    }


    if (!this.addPtcFourAxleAllotment || (this.addPtcFourAxleAllotment && this.addPtcFourAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addPtcFourAxleAllotment)) {
      flag = false;
      this.addPtcFourAxleAllotmentError = true;
    }
    if (!this.addPtcSixAxleAllotment || (this.addPtcSixAxleAllotment && this.addPtcSixAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addPtcSixAxleAllotment)) {
      flag = false;
      this.addPtcSixAxleAllotmentError = true;
    }
    if (!this.addPtcRclFourAxleAllotment || (this.addPtcRclFourAxleAllotment && this.addPtcRclFourAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addPtcRclFourAxleAllotment)) {
      flag = false;
      this.addPtcRclFourAxleAllotmentError = true;
    }
    if (!this.addPtcRclSixAxleAllotment || (this.addPtcRclSixAxleAllotment && this.addPtcRclSixAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addPtcRclSixAxleAllotment)) {
      flag = false;
      this.addPtcRclSixAxleAllotmentError = true;
    }
    if (!this.addSlugAllotment || (this.addSlugAllotment && this.addSlugAllotment.trim().length === 0) || !this.isIntegerVal(this.addSlugAllotment)) {
      flag = false;
      this.addSlugAllotmentError = true;
    }
    if (!this.addPtcSlugAllotment || (this.addPtcSlugAllotment && this.addPtcSlugAllotment.trim().length === 0) || !this.isIntegerVal(this.addPtcSlugAllotment)) {
      flag = false;
      this.addPtcSlugAllotmentError = true;
    }
    if (!this.addRclFourAxleAllotment || (this.addRclFourAxleAllotment && this.addRclFourAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addRclFourAxleAllotment)) {
      flag = false;
      this.addRclFourAxleAllotmentError = true;
    }
    if (!this.addRclSixAxleAllotment || (this.addRclSixAxleAllotment && this.addRclSixAxleAllotment.trim().length === 0) || !this.isIntegerVal(this.addRclSixAxleAllotment)) {
      flag = false;
      this.addRclSixAxleAllotmentError = true;
    }
    if (!this.addPlatform || (this.addPlatform && this.addPlatform.trim().length === 0) || !this.isIntegerVal(this.addPlatform)) {
      flag = false;
      this.addPlatformError = true;
    }
    if (!this.addAxleFourAllotment || (this.addAxleFourAllotment && this.addAxleFourAllotment.trim().length === 0) || !this.isIntegerVal(this.addAxleFourAllotment)) {
      flag = false;
      this.addAxleFourAllotmentError = true;
    }
    if (!this.addAxleSixAllotment || (this.addAxleSixAllotment && this.addAxleSixAllotment.trim().length === 0) || !this.isIntegerVal(this.addAxleSixAllotment)) {
      flag = false;
      this.addAxleSixAllotmentError = true;
    }

    return flag;
  }

  /**
   * Load division list.
   * @memberof YardLocalDataComponent
   */
  loadDivisionList() {
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.masterData.divisonList) {
      this.divisionList = [];
      this.divisionList.push({
        label: 'Select Division',
        value: ''
      });
      const divisionArr: Array<TerminalDivision> = this.commonopsPicklist.masterData.divisonList;
      if (divisionArr) {
        for (const terminalDivision of divisionArr) {
          this.divisionList.push({
            label: terminalDivision.divisionMenmonic + ' ' + terminalDivision.divisionName,
            value: terminalDivision.divisionMenmonic
          });
        }
      }
    }
  }

  convertStationLocoToLocoDetail(stationLocoDetail: StationLocoDetail): LocoDetail {
    let locoDetail = {};
    if (stationLocoDetail) {

      const listOfFeature: Array<LocoFeature> = [];
      for (let i = 0; i < stationLocoDetail.features.length; i++) {
        const locoFeature = {
          featureDescription: stationLocoDetail.features[i]
        };
        listOfFeature.push(locoFeature);
      }

      locoDetail = {
        shadowIndicator: stationLocoDetail.shadowIndicator,
        locomotiveIdentifier: stationLocoDetail.locomotive,
        duration: stationLocoDetail.duration,
        directionFacing: stationLocoDetail.directionFacing,
        shoppedStored: stationLocoDetail.shoppedStored,
        clazz: stationLocoDetail.clazz,
        partialPower: stationLocoDetail.partialPower,
        trailUseOnly: stationLocoDetail.trailUseOnly,
        gpsIdleHours: stationLocoDetail.gpsIdleHrs,
        specificGPSIdle: stationLocoDetail.specificGpsIdl,
        axles: stationLocoDetail.axles,
        permanentTag: stationLocoDetail.permanentTag,
        locoTag: stationLocoDetail.locomotiveTag,
        questionMark: stationLocoDetail.questionMark,
        rduInstalled: stationLocoDetail.telemetry,
        alertLevel: stationLocoDetail.labAlertLevel,
        lowFuelIndicator: stationLocoDetail.lowFuelInd,
        formDue: stationLocoDetail.formDue,
        deadFlag: stationLocoDetail.deadProblem,
        otherFlag: stationLocoDetail.otherProblem,
        ptcIncident: stationLocoDetail.ptcIncident,
        ptcEquipped: stationLocoDetail.ptcEquipped,
        formPastDue: stationLocoDetail.formPastDue,
        miles: stationLocoDetail.milesRemaining,
        lastFueledDate: stationLocoDetail.lastFueledMMDD,
        xFormDue: stationLocoDetail.xFormDue,
        serviceDue: stationLocoDetail.serviceDue,
        horsePower: stationLocoDetail.horsePower,
        tractiveEffort: stationLocoDetail.tractiveEffort,
        capacity: stationLocoDetail.capacity,
        plannedAssignment: stationLocoDetail.planCurrAsgn,
        qDueDate: stationLocoDetail.qDueDate,
        maintenanceType: stationLocoDetail.maintenanceType,
        deadDate: stationLocoDetail.deadDate,
        thpTerminal: stationLocoDetail.thpTerminalI,
        thpType: stationLocoDetail.thpTypeC,
        thpText: stationLocoDetail.thpTypeDescX,
        responsibleRoad: stationLocoDetail.responsibleScacC,
        locoAllocDiv: stationLocoDetail.locoAllocDiv,
        locoAllocStation: stationLocoDetail.locoAllocStat,
        locoAllocType: stationLocoDetail.locoAllocType,
        locoAllocPermFlag: stationLocoDetail.allocPermFlag,
        bestAvailableLocDetail: stationLocoDetail.lastRptInfo,
        terminalArrival: stationLocoDetail.terminalArrv,
        terminalDuration: stationLocoDetail.termDuration,
        previousAssignment: stationLocoDetail.prevAssignment,
        lastReportingSource: stationLocoDetail.lastRptSource,
        lastReportingDateTime: stationLocoDetail.lastRptDateTm,
        lastReportingMilepost: stationLocoDetail.lastRptMp,
        lastReportingCityState: stationLocoDetail.lastRptCitySt,
        tripPlans: this.getTripPlans(stationLocoDetail),
        backupTripPlan: stationLocoDetail.backupTripPlan,
        problemCodes: stationLocoDetail.problemCodes,
        remarks: stationLocoDetail.remarks,
        noteText: stationLocoDetail.noteText,
        listOfFeature: listOfFeature,
        assignedPlannedFlag: stationLocoDetail.assignedPlanned,
        intendedUsageCode: stationLocoDetail.intendUsageC,
        intendedUsageReason: stationLocoDetail.intendUsageRsnC,
        intendedUsgaeNote: stationLocoDetail.intendUsageNteX,
        backgroundColor: stationLocoDetail.backgroundColor,
        noGpsReporting: stationLocoDetail.noGpsReporting,
        textAboveLoco: stationLocoDetail.textAboveLoco,
        textBelowLoco: stationLocoDetail.textBelowLoco,
        notesFlag: stationLocoDetail.notesExist,
        trfIncidentS: stationLocoDetail.trfIncidentS
      };
    }
    return locoDetail;
  }

  getTripPlans(stationLocoDetail: StationLocoDetail): Array<string> {
    const tripPlans: Array<string> = [];
    if (stationLocoDetail) {
      for (let i = 1; i <= 9; i++) {
        if (stationLocoDetail['tripPlan0' + i]) {
          tripPlans.push(stationLocoDetail['tripPlan0' + i]);
        }
      }
      if (stationLocoDetail.tripPlan10) {
        tripPlans.push(stationLocoDetail.tripPlan10);
      }
    }
    return tripPlans;
  }

  public ruleExceptionSubmit() {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    const locoTransfer: Array<LocoTransfer> = [];
    for (let j = 0; j < this.selectedLocoDetailForPlanToTrainArr.length; j++) {
      const selectedLocmotive = this.selectedLocoDetailForPlanToTrainArr[j];
      for (let i = 0; i < this.lmsExceptionList.length; i++) {
        const lmsException: LmsException = this.lmsExceptionList[i];
        if (lmsException.isSelectedLoco) {
          let isException = false;
          if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
            if (!lmsException.tripPlanOverrideCode) {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddReason = false;
            }
          }
          if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
            if (!lmsException.unscheduledQShop) {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = true;
              isException = true;
            } else {
              this.lmsExceptionList[i].isLmsExceptionInAddQShop = false;
            }
          }
          if (!isException) {
            if (this.appUtilityService.formatLocomotiveId(lmsException.locoId).replace('    ', '') ===
              this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier).replace('    ', '')) {
              const a = {
                currentTerminalIdentifier: selectedLocmotive.currentTerminalId,
                terminalHandlingType: this.yardLocalThpType,
                trainIdentifier: this.searchTextTrain,
                locoTransferList: {
                  locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                  qualifier: selectedLocmotive.qualifier,
                  assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                  tripPlanCompIndicator: lmsException.tripPlamCompExcptnInd,
                  tripPlanTrainIdentifier: lmsException.tripPlanTrnId,
                  tripPlanOverrideCode: lmsException.tripPlanOverrideCode,
                  tripPlanOverrideReason: lmsException.tripPlanOverrideReason,
                  unscheduledQShop: lmsException.unscheduledQShop,
                  unscheduledQShopDate: lmsException.unscheduledQShopDate,
                  intendedUsageCode: selectedLocmotive.intendedUsageCode,
                  intendedUsageReason: selectedLocmotive.intendedUsageReason,
                  intendedUsageNotes: selectedLocmotive.intendedUsageNote
                }
              };
              locoTransfer.push(a);
            }
          }
        }
      }
    }
    if (locoTransfer && locoTransfer.length > 0) {
      this.ruleException = false;
      this.planLocomotive = true;
      this.popupErrorMessage = 'Plan Locomotive';
      this.serviceCallLocoTransfer(locoTransfer, 'XTRN');
    }
  }

  getLocoIncident() {
    if (this.selectedLocoDetailForPlanToTrainArr) {
      for (let i = 0; i < this.selectedLocoDetailForPlanToTrainArr.length; i++) {
        const locoData: LocoDetail = this.selectedLocoDetailForPlanToTrainArr[i];
        if (locoData) {
          if (locoData.deadFlag && locoData.deadFlag.trim().toUpperCase() === 'Y') {
            this.selectedLocoDetailForPlanToTrainArr[i].locoIncident = 'OOS';

          } else if (locoData.trfIncidentS && locoData.trfIncidentS.trim().toUpperCase() === 'Y') {
            this.selectedLocoDetailForPlanToTrainArr[i].locoIncident = 'TRF';

          } else if (locoData.axles && locoData.axles.trim() === '4') {
            this.selectedLocoDetailForPlanToTrainArr[i].locoIncident = '4-ax';

          } else if (!locoData.axles || (locoData.axles && (locoData.axles.trim().length === 0 || locoData.axles.trim() === '6'))) {
            this.selectedLocoDetailForPlanToTrainArr[i].locoIncident = '6-ax';

          }
        }
      }
    }
    this.planLocomotive = true;
  }

  getIntegerVal(value: string) {
    if (value && value.trim().length !== 0 && !isNaN(parseInt(value, 10))) {
      return parseInt(value, 10);
    }
    return '0';
  }

  isIntegerVal(value: string) {
    if (value && value.trim().length !== 0 && !isNaN(parseInt(value, 10))) {
      return true;
    }
    return false;
  }
}
